import { render, staticRenderFns } from "./SingleCategoryStaticPagesList.vue?vue&type=template&id=8a53e6fe&scoped=true"
import script from "./SingleCategoryStaticPagesList.vue?vue&type=script&lang=js"
export * from "./SingleCategoryStaticPagesList.vue?vue&type=script&lang=js"
import style0 from "./SingleCategoryStaticPagesList.vue?vue&type=style&index=0&id=8a53e6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a53e6fe",
  null
  
)

export default component.exports